import { createAction } from '@wix/communities-blog-client-common';

export const SET_APP_SETTINGS = 'appSettings/SET_APP_SETTINGS';
export const setAppSettingsAction = createAction(SET_APP_SETTINGS);

export const setAppSettings = (payload) => (dispatch) => {
  dispatch(setAppSettingsAction(payload));
  return Promise.resolve();
};
